// extracted by mini-css-extract-plugin
export var component = "Bookable-module--component--+MuJ5";
export var date = "Bookable-module--date--U9hPM";
export var day = "Bookable-module--day--x5h7Z";
export var isUnavailable = "Bookable-module--isUnavailable--qnsm-";
export var month = "Bookable-module--month--euNAG";
export var timeslot = "Bookable-module--timeslot--mpRID";
export var timeslots = "Bookable-module--timeslots--JtCy3";
export var toggle = "Bookable-module--toggle--7bG0t";
export var visuallyHidden = "Bookable-module--visuallyHidden--Ax08E";